// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import elementUi from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Plugin from 'v-fit-columns'
// import BaiduMap from 'vue2-baidu-map'

console.log(elementUi)
Vue.prototype.$axios = axios
axios.defaults.withCredentials = true
console.log(axios)
Vue.config.productionTip = false
Vue.use(Plugin)
Vue.use(elementUi)
// Vue.use(BaiduMap, {
//   ak: 'JYgOLwj4fWirhmweskykV5duHI7H30N6'
// })
// Vue.use(ViewUIPlus)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js